import { ptBR } from "./pt-BR";

export const t = ptBR;

/** Substitui `{chave}` por valores. */
export function fmt(template: string, vars: Record<string, string | number | null | undefined>): string {
  return template.replace(/\{(\w+)\}/g, (_, k: string) => {
    const v = vars[k];
    return v === null || v === undefined ? "" : String(v);
  });
}

export function stateLabel(state: string): string {
  return t.states[state] ?? state;
}

export type Tone = "ok" | "go" | "warn" | "mute" | "crit";
export const STATE_TONES: Record<string, Tone> = {
  quoted: "warn",
  awaiting_funds: "mute",
  funds_received: "go",
  executing: "go",
  sent: "go",
  settled: "ok",
  failed: "crit",
  refunded: "mute",
  expired: "mute",
  under_review: "warn",
};
export function stateTone(state: string): Tone {
  return STATE_TONES[state] ?? "mute";
}
